import React from 'react';
import { getNameMonth } from '~/src/helpers/date';

import {
    Wrapper,
    Header,
    HeaderWrapper,
    Title,
    Description,
    Footer,
    Button,
    InfoWrapper,
    Pause,
} from './styled';

const CardChannel = ({ title,
    cost,
    dateOff,
    channels,
    color,
    onSubscribeClick,
    onDisconnectClick,
    onChannelClick,
    onClickResumption,
    state,
    ...props }) => {
    const currentDate = new Date(dateOff * 1000);
    const dateString = dateOff ? ` - активен по ${currentDate.getDate()} ${getNameMonth(currentDate.getMonth())} ${currentDate.getFullYear()} года` : ' - подключен бессрочно';

    let buttonClickFunc = onSubscribeClick;
    if (state.prolong === 1) {
 buttonClickFunc = onClickResumption;
}

    let footer = (
        <React.Fragment>
            {state.unsetState !== 4 && <Button type='secondary' text='Управление подпиской' onClick={buttonClickFunc}/>}
            <Button type='primary' text='Посмотреть каналы' onClick={onChannelClick}></Button>
        </React.Fragment>
    );

    if (dateOff === null && state.prolong !== 1) {
        footer = (
            <React.Fragment>
                <Button type='secondary' text='Отключить пакет' onClick={onDisconnectClick}/>
                <Button type='primary' text='Посмотреть каналы' onClick={onChannelClick}/>
            </React.Fragment>
        );
    }

    return (
        <Wrapper {...props}>
            <Header style={{ 'background': color }}>
                <HeaderWrapper>
                    <Title> {title} </Title>
                    <Description
                        dangerouslySetInnerHTML={{ __html: cost + ' &#8381;/мес.' + dateString }}
                    />
                </HeaderWrapper>
                <InfoWrapper
                  longDesktop={title.length > 35 || (cost + ' &#8381;/мес.' + dateString).length > 55}
                  longDesktopSmall={title.length > 29 || (cost + ' &#8381;/мес.' + dateString).length > 44}
                >
                    <Title> {channels} </Title>
                    { state.prolong === 1 && <Pause> Приостановлен </Pause>
                    }
                </InfoWrapper>
            </Header>
            <Footer>
                {footer}
            </Footer>
        </Wrapper>
    );
  };

export default CardChannel;
